'use client';

import { Body, Heading } from '@depop/web-thrift-ui/Typography';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { Container } from '@/components/Container';

export function WhyTrustDepop() {
  const WEB_ASSETS_SAFETY_PATH = `${process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST}/web/assets/trustPage/`;

  const t = useTranslations('safety');

  return (
    <section className={styles.section}>
      <Container className={styles.container}>
        <div className={styles.textWrapper}>
          <Heading as="h2">{t('SafetyPage.WhyTrustDepop.Title')}</Heading>
          <div className={styles.sectionsWrapper}>
            <div>
              <Body variant="md-bold" className={styles.subheading}>
                {t('SafetyPage.WhyTrustDepop.Subheading1')}
              </Body>
              <Body variant="md-regular">
                {t('SafetyPage.WhyTrustDepop.Section1')}
              </Body>
            </div>
            <div>
              <Body variant="md-bold" className={styles.subheading}>
                {t('SafetyPage.WhyTrustDepop.Subheading2')}
              </Body>
              <Body variant="md-regular">
                {t('SafetyPage.WhyTrustDepop.Section2')}
              </Body>
            </div>
          </div>
        </div>
        <div className={styles.imageWrapper}>
          <picture>
            <source
              type="image/avif"
              media="(min-width: 768px)"
              srcSet={`${WEB_ASSETS_SAFETY_PATH}why-trust-depop-desktop.avif`}
            />
            <img
              src={`${WEB_ASSETS_SAFETY_PATH}why-trust-depop-mobile.png`}
              alt=""
            />
          </picture>
        </div>
      </Container>
    </section>
  );
}
